module.exports = __webpack_public_path__ + "img/logowhite .e3fa8e84.svg";